import { createSelector } from '@reduxjs/toolkit';

import { selectUndergroundMapState } from './selectUndergroundMapState';

export const selectUndergroundMapManifest = createSelector(selectUndergroundMapState, state => state.manifest);
